module.exports = __webpack_public_path__ + "static/img/picture15.e81a1c5b.png";